/**
 * ProjectSurfaceContext — the project page's binding of the shared
 * detail-surface context.
 *
 * The machinery (an optional context, a typed API) is in
 * `shared/surface/DetailSurfaceContext`. What is particular to projects is
 * one line: which pane ids exist.
 *
 * NO SELECTION, NO READER. The project page edits its record inline on the
 * Details tab and everything else opens a route or a side panel, and nothing
 * on it opens a document in place. It used to have to name a selection `Kind`
 * anyway (pinned to `string`) because the API was one interface; it is in
 * thirds now, so a page composes only the thirds it has —
 * `DetailSurfaceApiWithoutSelection` is panes and tabs and nothing else.
 *
 * IT IS OPTIONAL ON PURPOSE. `useProjectSurface()` returns null outside the
 * provider, so a tab component rendered anywhere else keeps working: the call
 * sites fall back to whatever they did before the surface existed.
 */

import {
  DetailSurfaceApiWithoutSelection,
  createDetailSurfaceContext,
} from '../../shared/surface/DetailSurfaceContext';
import { ProjectPanelId } from './layout';

export type ProjectSurfaceApi = DetailSurfaceApiWithoutSelection<ProjectPanelId>;

const binding = createDetailSurfaceContext<ProjectSurfaceApi>();

export const ProjectSurfaceProvider = binding.Provider;

/** Null outside a project surface — callers fall back to their old behaviour. */
export const useProjectSurface = binding.useSurface;

export default binding.Context;
